import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import Text from '../../../../shared/_TBComponents/Text';
import ResetPasswordForm from './ResetPasswordForm';
import Logo from '../../../../shared/images/full-logo-black-orange.png';
import ValidationError from './ValidationError';
import Spinner from '../../../../shared/_TBComponents/Spinner';
import useReset from '../hooks/useReset';
import getAllUrlParams from '../../../../shared/utils/getAllUrlParams';

const FormArea = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const FormContainer = styled('div')`
  background-color: #FFFFFF;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  height: auto;
  padding: 60px 48px;
  width: 440px;
`;

const TitleArea = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 40px;

  img {
    align-self: center;
    width: 250px;
  }
`;

const ResetContainer = ({ isSetPassword }) => {
  const isValidating = useSelector((state) => state.forgot.ui.isValidating);
  const validateError = useSelector((state) => state.forgot.ui.validateError);

  const {
    handleResetLogOut,
    handleValidate,
    handleValidateSet,
  } = useReset();

  const url = getAllUrlParams(window.location.href, false);
  const tokenString = url.token;

  // Validate token on initial page load
  useEffect(() => {
    handleResetLogOut();
    if (isSetPassword) {
      handleValidateSet({ token: tokenString });
    } else {
      handleValidate({ token: tokenString });
    }
  }, []);

  if (validateError) {
    return (
      <ValidationError isSetPassword={isSetPassword} validateError={validateError} />
    );
  }

  return (
    <FormContainer>
      {isValidating ? <Spinner /> : (
        <>
          <TitleArea>
            <img src={Logo} alt='Teambuildr' className='img-fluid' />
            <Text styledTextProps={{ fontSize: '23px', fontWeight: '700' }}>{isSetPassword ? 'Set your password' : 'Reset your password'}</Text>
          </TitleArea>
          <FormArea>
            <ResetPasswordForm isSetPassword={isSetPassword} tokenString={tokenString} />
          </FormArea>
        </>
      )}
    </FormContainer>
  );
};

ResetContainer.propTypes = {
  isSetPassword: PropTypes.bool,
};

ResetContainer.defaultProps = {
  isSetPassword: false,
};

export default ResetContainer;
